import React, { ReactElement } from 'react';
import { BaseEntite } from '../../../../../../common/src/entities';
import ChampCascadeUnresolvedContentFromLocal from "./ChampCascadeUnresolvedContentFromLocal";
import ChampCascadeUnresolvedContentFromRemote from "./ChampCascadeUnresolvedContentFromRemote";
import { InjectionReference } from "../InjectionHelper"

export interface PropsDeChamp<T, TEntite extends BaseEntite> {
    children: ReactElement;
    injectionValue?: T;
    injectionReferenceToResolved?: InjectionReference<T, TEntite>;
    notifyResolvedValue: (resolvedValue: T | T[keyof T] | TEntite | TEntite[]) => void;
};

export default function ChampCascadeUnResolvedContent<T, TEntite extends BaseEntite>(props: PropsDeChamp<T, TEntite>): ReactElement {
    const {
        injectionReferenceToResolved,
    } = props;

    return injectionReferenceToResolved && (("entite" as keyof InjectionReference<T, TEntite>) in injectionReferenceToResolved) && injectionReferenceToResolved.entite
            ? <ChampCascadeUnresolvedContentFromRemote {...props}/>
            : <ChampCascadeUnresolvedContentFromLocal {...props}/>;
}
